<template>
    <div>
        <div class="d-flex">
            <h5 class="mb-3 mr-3">{{ $t('talk.modal.networkTypes') }}</h5>
            <Loader :showMessage="false" :loader="isLoading" :size="20" />
        </div>
        <div class="d-flex align-items-center justify-content-start">
            <b-form-checkbox-group v-model="model" :state="state">
                <b-form-checkbox
                    v-for="option in options"
                    :key="`checkbox-${option.type}`"
                    class="mr-4"
                    :value="option.type"
                >
                    <span class="checkbox-network">{{
                        $t('values.table.' + option.type)
                    }}</span>
                </b-form-checkbox>
            </b-form-checkbox-group>
        </div>
    </div>
</template>

<script>
import Loader from '@/views/components/loader'
export default {
    name: 'NetworkTypesCheckboxes',
    components: {
        Loader,
    },
    props: {
        state: {
            default: null,
            type: Boolean | null,
        },
        selected: {
            type: Array,
            required: true,
        },
        isLoading: {
            type: Boolean,
            default: false,
        },
        options: {
            type: Array,
            default: null,
        },
    },
    computed: {
        model: {
            get() {
                return this.selected
            },
            set(value) {
                this.$emit('update:selected', value)
            },
        },
    },
}
</script>

<style lang="sass" scoped>
$darkBlue: #022B4F
.checkbox-network
    font-size: 13px
    color: #23282c
::v-deep
    .was-validated .custom-control-input:valid:checked ~ .custom-control-label::before, .custom-control-input.is-valid:checked ~ .custom-control-label::before
        background-color: $darkBlue !important
        border-color: $darkBlue !important
    .was-validated .custom-control-input:valid ~ .custom-control-label::before, .custom-control-input.is-valid ~ .custom-control-label::before
        border-color: $darkBlue
    .was-validated .custom-control-input:valid:focus:not(:checked) ~ .custom-control-label::before, .custom-control-input.is-valid:focus:not(:checked) ~ .custom-control-label::before
        border-color: $darkBlue
    .was-validated .custom-control-input:valid:focus ~ .custom-control-label::before, .custom-control-input.is-valid:focus ~ .custom-control-label::before
        box-shadow: 0 0 0 0.2rem rgba(2, 43, 79, 0.25)
</style>
